import React from 'react';

function DefaultButton({
  disabled = false, children, className, type = 'button', onClick = () => {},
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={`bg-primary text-white rounded-lg p-[19px] border-0 cursor-pointer ease-out duration-300 ${disabled && 'opacity-50 cursor-not-allowed'} ${className}`}
    >
      {children}
    </button>
  );
}

export default DefaultButton;
